import { Navigate, useSearchParams} from "react-router-dom";
import useDepartmentAuth from "../hooks/useDepartmentAuth";

const RequireDepartmentAuth = ({ children }) => {
    const [searchParams] = useSearchParams();
    const telegramHash = searchParams.get('telegramHash');

    localStorage.setItem('telegramHashRequireDepartmentAuth', telegramHash);
    console.log('telegramHash RequireDepartmentAuth :>> ', telegramHash);
    const { department } = useDepartmentAuth();
    if (!department?.decoded) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default RequireDepartmentAuth;
